import { getIsLawyerAndUser } from 'Utils/lawyers';
import { useAppSelector } from './useAppSelector';

export const useIsLawyer = () => {
  const imposter = useAppSelector(({ imposter }) => imposter);
  return getIsLawyerAndUser()
    ? sessionStorage.getItem('isLawyer') === 'true'
    : imposter.isLawyer;
};
